import type { Issue } from './api'

// The problems a form is showing, kept true while the person fixes them.
//
// A form lists what is wrong when its main action is pressed. The list used
// to stand until the next press, so the footer went on saying "8 things to
// fix" after six of them had been fixed. After each edit the list is now what
// is still wrong: a problem the form found itself goes when its own check no
// longer finds it, and one only the server found goes when its field is
// edited, since the form cannot check it. Nothing is added while somebody is
// typing: a new problem is said at the next press, as before.

export type Listed = Issue & { byServer?: true }

export function fromServer(issues: Issue[]): Listed[] {
  return issues.map((i) => ({ ...i, byServer: true as const }))
}

// `fresh` is the form's own check run on what is typed now.
export function afterEdit(listed: Listed[], edited: string, fresh: Issue[]): Listed[] {
  const out: Listed[] = []
  for (const i of listed) {
    if (i.byServer) {
      if (i.field !== edited) out.push(i)
      continue
    }
    const now = fresh.find((f) => f.field === i.field)
    if (now && !out.some((o) => !o.byServer && o.field === now.field)) out.push(now)
  }
  return out
}

// The problems that name a field the form does not draw. They have no field
// to sit under, so the form says them in its summary; otherwise the footer
// would count a problem nobody can find.
export function unplaced(listed: Issue[], drawn: string[]): Issue[] {
  return listed.filter((i) => !drawn.includes(i.field))
}
